var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.$t(_vm.label),"prepend-icon":"insert_chart","value":_vm.value,"items":_vm.types,"multiple":"","clearable":"","disabled":_vm.disabled},on:{"input":_vm.selectStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }